import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";

function Index(props) {
    const [subjects, setSubjects] = useState([]);
    const [subject, setSubject] = useState({
        title: "",
        detected: "",
        expectedResult: "",
        suggestions: [],
        questions: [],
    });
    const [inputSuggestions, setInputSuggestions] = useState({});
    const [inputQuestions, setInputQuestions] = useState({});

    const updateSubjects = (index, field, value) => {
        const updatedSubjects = [...subjects];
        updatedSubjects[index] = {
            ...updatedSubjects[index],
            [field]: value,
        };
        setSubjects(updatedSubjects);
    };

    const addToArrayField = (index, field, value) => {
        if (value.trim()) {
            const updatedSubjects = [...subjects];
            updatedSubjects[index] = {
                ...updatedSubjects[index],
                [field]: [...updatedSubjects[index][field], value],
            };
            setSubjects(updatedSubjects);
            if (field === "suggestions") {
                setInputSuggestions((prev) => ({ ...prev, [index]: "" }));
            } else if (field === "questions") {
                setInputQuestions((prev) => ({ ...prev, [index]: "" }));
            }
        }
    };

    const generateText = () => {
        return (
            "سلام و احترام \n" +
            subjects
                .map((e, i) => `
موضوع${i + 1}: ${e.title}
برداشت من: ${e.detected}
خروجی‌های مورد انتظار: ${e.expectedResult}
اقدامات پیشنهادی:\n${e.suggestions.map((s) => `- ${s}`).join("\n")}
سوالات یا ابهامات:\n${e.questions.map((q) => `- ${q}`).join("\n")}`)
                .join("\n")
        );
    };

    return (
        <div className="w-full flex gap-2 align-items-center justify-content-center">
            <div className="w-6 h-full flex flex-column bg-white border-round shadow-2 p-3 gap-2 justify-content-between" style={{ maxHeight: "70vh", overflow: "auto" }}>
                <div className="flex gap-2">
                    <InputText
                        className="w-full"
                        placeholder="موضوعات مطرح‌شده"
                        value={subject.title}
                        onChange={(e) =>
                            setSubject({
                                ...subject,
                                title: e.target.value,
                            })
                        }
                    />
                    <Button
                        icon="pi pi-plus-circle"
                        onClick={() => {
                            if (subject.title) {
                                setSubjects([...subjects, subject]);
                                setSubject({
                                    title: "",
                                    detected: "",
                                    expectedResult: "",
                                    suggestions: [],
                                    questions: [],
                                });
                            }
                        }}
                    />
                </div>
                <ul
                    className="flex-column gap-2 m-0"
                    style={{ maxHeight: "60vh", overflowY: "auto", padding: 0 }}
                >
                    {subjects.map((e, i) => (
                        <li key={i} className="mb-3">
                            <div className="flex gap-1 p-1">
                                <span className="font-bold">{`موضوع${i + 1}`}</span>: <span>{e.title}</span>
                            </div>
                            <div className="flex gap-2">
                                <InputText
                                    className="w-full"
                                    placeholder={`برداشت من از موضوع${i + 1}`}
                                    value={e.detected}
                                    onChange={(e) =>
                                        updateSubjects(i, "detected", e.target.value)
                                    }
                                />
                            </div>
                            <div className="flex gap-2 mt-2">
                                <InputText
                                    className="w-full"
                                    placeholder={`خروجی‌های مورد انتظار موضوع${i + 1}`}
                                    value={e.expectedResult}
                                    onChange={(e) =>
                                        updateSubjects(i, "expectedResult", e.target.value)
                                    }
                                />
                            </div>
                            <div className="flex flex-column gap-2 mt-2">
                                <div className="flex gap-2">
                                    <InputText
                                        className="w-full"
                                        placeholder={`اقدام پیشنهادی جدید برای موضوع${i + 1}`}
                                        value={inputSuggestions[i] || ""}
                                        onChange={(e) =>
                                            setInputSuggestions((prev) => ({
                                                ...prev,
                                                [i]: e.target.value,
                                            }))
                                        }
                                    />
                                    <Button
                                        icon="pi pi-plus"
                                        onClick={() => {
                                            addToArrayField(
                                                i,
                                                "suggestions",
                                                inputSuggestions[i] || ""
                                            );
                                        }}
                                    />
                                </div>
                                <ul>
                                    {e.suggestions.map((s, idx) => (
                                        <li key={idx}>{s}</li>
                                    ))}
                                </ul>
                            </div>
                            <div className="flex flex-column gap-2 mt-2">
                                <div className="flex gap-2">
                                    <InputText
                                        className="w-full"
                                        placeholder={`سوال جدید برای موضوع${i + 1}`}
                                        value={inputQuestions[i] || ""}
                                        onChange={(e) =>
                                            setInputQuestions((prev) => ({
                                                ...prev,
                                                [i]: e.target.value,
                                            }))
                                        }
                                    />
                                    <Button
                                        icon="pi pi-plus"
                                        onClick={() => {
                                            addToArrayField(
                                                i,
                                                "questions",
                                                inputQuestions[i] || ""
                                            );
                                        }}
                                    />
                                </div>
                                <ul>
                                    {e.questions.map((q, idx) => (
                                        <li key={idx}>{q}</li>
                                    ))}
                                </ul>
                            </div>
                        </li>
                    ))}
                </ul>
                <Button
                    label="کپی متن"
                    className="mt-3"
                    onClick={() => {
                        navigator.clipboard.writeText(generateText()).then(() => {
                            alert("متن کپی شد!");
                        }).catch(err => {
                            console.error("خطا در کپی کردن متن:", err);
                        });
                    }}
                />
            </div>

            <div
                className="w-5 flex-column bg-white border-round shadow-2 p-3 gap-2 h-full hidden"
                style={{ maxHeight: "80vh", overflow: "auto" }}
            >
                <InputTextarea className="h-full" value={generateText()} readOnly />
            </div>
        </div>
    );
}

export default Index;